<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="getTitle">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'logBookLists' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>Back
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
              class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveTopic">
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium">Select Academic Year <span
                    class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="academicYearID"
                  required :items="academicYears" key="id" item-value="id" item-text="academicYear">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium"> Topic Name <span
                    class="error--text">*</span></label>
                <v-text-field class="my-0 py-1" placeholder="Enter topic" v-model.trim="topicName"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-card-actions class="d-flex justify-center">
                  <v-btn bottom right elevation="1" color="primary" type="submit" class="add-btn">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
          <v-card-title>
            Topics
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider class=" my-0 " />

          <!-- <v-data-table :footer-props="{
          'items-per-page-options': [5, 10, 20, 40] }" :items-per-page="4" :headers="headers"
            :items="topics" disable-pagination :hide-default-footer="true" item-key="srno"> -->
          <v-data-table :headers="headers" :items="topics" :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }" :items-per-page="10" item-key="srno">

            <template v-slot:[`item.name`]="{ item }">
              <span class="text-capitalize">{{ item.name}} </span>
            </template>
            <template v-slot:item.academicYear="{ item }">
              {{ item.academicYear.academicYear ? item.academicYear.academicYear : '-' }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small
                @click.prevent="editTopic(item)">
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
              <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt"
                @click.prevent="deleteTopic(item)">
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>

        </v-card>
        <v-dialog v-model="editModalOk" width="600px" :active="editModalOk" :on-cancel="
        () => {;(editModalOk = false), closeEdit()}">
          <form>
            <v-card>
              <v-toolbar dark color="darkblue">
                <v-toolbar-title> Update Topic</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="
                    () => {
                      ;(editModalOk = false), closeEdit()
                    }
                  ">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text v-if="editTopicData">
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="body-2 font-weight-medium"> Topic Name <span
                        class="error--text">*</span></label>
                    <v-text-field v-model.trim="editTopicData.name" placeholder="Topic Name"
                      required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-card-actions class="justify-end">
                      <v-btn
                        @click="() => {;(editModalOk = false), (editTopicData.id = ''), closeEdit()}">
                        Close </v-btn>
                      <v-btn color="primary" @click="saveEditTopic()">Save</v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </form>
        </v-dialog>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
// import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'topicLists',
  components: { MaterialCard },

  data () {
    return {
      isLoading: false,
      getTitle: 'Add Topic',
      academicYears: [],
      academicYearID: '',
      topicName: '',
      isActive: true,
      topics: [],
      editMode: false,
      editModalOk: false,
      editTopicData: '',
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      loadingComponent: null,
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Topic Name', value: 'name', sortable: true },
        { text: 'Academic Year', value: 'AcademicYear.academicYear', align: 'center' },
        { text: 'Action', value: 'actions', sortable: false }
      ]
    }
  },

  async created () {
    await this.getAcademicYear()
    await this.getTopicAllList()
  },
  computed: {
    ...mapGetters({
      academicYear: 'getAcademicYear'
    })
  },
  beforeDestroy () {
    let elements = document.getElementsByClassName('vuedl-layout__closeBtn')
    if (elements.length > 0) {
      elements[0].click()
    }
  },
  methods: {
    getAcademicYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    saveTopic: async function () {
      if (!this.topicName) {
        this.errMsg('Please enter Topic Name')
        return false
      }
      let formData = {
        academicYearID: this.academicYearID,
        name: this.topicName,
        isActive: 'true'
      }
      try {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/log-book/add-topic`, formData)
        this.okMsg('Topic Added successfully!')
        this.topicName = ''
        this.getTopicAllList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getTopicAllList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/log-book/getall-topic`, {
          params: {
            page: this.page - 1,
            size: this.pageSize
          }
        })
        this.topics = res.data.rows.map((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
          return item
        })

        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteTopic: function (item) {
      this.$dialog.warning({
        title: item.isActive === true ? 'Deactivate' : 'Topics',
        text: 'Are you sure you want to delete this Topic?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',

            handle: async () => {
              try {
                this.isLoading = true
                await http.put(`${constants.API_URL}/api/log-book/delete-topic/${item.id}`, {
                  isActive: 'false'
                })
                this.okMsg('Topic deleted successfully!')
                this.getTopicAllList()
                this.isLoading = false
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message

                return this.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    modalOpen () {
      this.modalOk = true
    },
    editTopic: async function (topicData) {
      try {
        this.isLoading = true
        this.editTopicData = topicData
        this.editModalOk = true
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    closeEdit: async function () {
      this.editModalOk = false
    },
    saveEditTopic: async function () {
      try {
        this.isLoading = true
        let res = await http.put(`${constants.API_URL}/api/log-book/update-topic/${this.editTopicData.id}`, {
          name: this.editTopicData.name
        })
        this.okMsg(res.data)
        this.isLoading = false
        this.editModalOk = false
        this.getTopicAllList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
.add-btn {
  margin-top: 15px;
}
</style>
